namespace GeniuzPOS.Purchase {
    export class PoPurOrderColumns {
        static columnsKey = 'Purchase.PoPurOrder';
    }
}
